const releaseVersionFile = `${import.meta.env.BASE_URL}version.txt`

/**
 * Version is written into the published dist by the release workflow. Keeping
 * it in a separate static file lets the cabinet show the version that is
 * actually deployed, rather than the version of the source used at build time.
 */
export const normalizeReleaseVersion = (value: string): string | null => {
  const version = value.trim()
  return /^v?\d+\.\d+\.\d+(?:[-+][0-9A-Za-z.-]+)?$/.test(version) ? version : null
}

export const loadReleaseVersion = async (): Promise<string | null> => {
  try {
    const response = await fetch(releaseVersionFile, { cache: 'no-store' })
    if (!response.ok) return null
    return normalizeReleaseVersion(await response.text())
  } catch {
    return null
  }
}
